import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a9d3e8586bf030014bb5308_1788848666863_b65b8337/shiporax_ai_ads/src/app/sign-up-login-screen/components/AuthScreen.tsx");
